import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles.css';
import './styles-phase2.css';
import './styles-phase3.css';
import './styles-phase4.css';
import './styles-layout.css';
import './styles-phase5.css';
import './styles-phase6.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

// MSAL renews tokens silently in a hidden iframe that lands on this page with Entra's response in the URL. Since MSAL 5
// the parent no longer reads that URL: the page in the frame must hand the response back through MSAL's redirect
// bridge (broadcastResponseToMainFrame), or the parent's renewal times out ("timed_out", redirect_bridge_timeout). In
// a frame, then, run only the bridge; the console itself starts only as the top window (it is never embedded).
if (window.self === window.top) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  import('@azure/msal-browser/redirect-bridge')
    .then((bridge) => bridge.broadcastResponseToMainFrame())
    .catch(() => {
      /* nothing for MSAL in this frame's URL: the parent's renewal reports the error */
    });
}
